export default __webpack_public_path__ + "static/media/OpenSans-BoldItalic.b2615551.woff";